import {Component, h, Prop} from '@stencil/core';
import {makeLogger} from '../../../logger/logger';
import type { labelProviderInterface } from '../../LabelProviderInterface';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/result-page/faq-breadcrumbs/faq-breadcrumbs.tsx',
  loggersList: ['warn']
});

@Component({
  tag: 'faq-breadcrumbs',
  scoped: false,
})
export class FaqBreadcrumbs {
    @Prop({mutable: true}) labelProvider?: labelProviderInterface;
    @Prop() readonly country: string;
    @Prop() readonly language: string;
    @Prop() readonly query: string;
    @Prop() readonly appName: string;
    @Prop() readonly supportUrl?: string;
    @Prop() readonly searchFaqsUrl?: string;

    private getHost(appName) {
        const hostsList = {
          'se' : 'se.com',
          'apc' : 'apc.com'
        };
        return hostsList[appName] || appName;
    }

    private calculateSupportUrl(){

        if(this.supportUrl)
          return this.supportUrl;

        return this.getHost(this.appName) ? `https://${this.getHost(this.appName)}/${this.country}/${this.language}/support/` : '#';
    }
    private calculateFaqsUrl(){
        if(this.searchFaqsUrl){
          return this.searchFaqsUrl;
        }
        return this.getHost(this.appName) ? `https://${this.getHost(this.appName)}/${this.country}/${this.language}/faqs/home/` : '#';
    }

    componentWillLoad() {
        if (!this.labelProvider) {
          this.labelProvider = (name, fallback) => {
              warn(
                'LabelProvider not provided in FaqBreadcrumbs component',
                [name, fallback]
              );
              return fallback;
          };
        }

    }

    render() {

        const supportUrl = this.calculateSupportUrl();
        const searchFaqsUrl = this.calculateFaqsUrl();


        return <se-breadcrumb>
          <se-breadcrumb-item
            href={supportUrl}
          > {this.labelProvider('breadcrumbs.support', 'Support')}
          </se-breadcrumb-item>
          <se-breadcrumb-item
            href={searchFaqsUrl}
          > {this.labelProvider('breadcrumbs.browseFaqs', 'Search FAQs')}
          </se-breadcrumb-item>
          <se-breadcrumb-item
            href="#"> {this.labelProvider('breadcrumbs.searchFor', 'Search for')} "{this.query}"
          </se-breadcrumb-item>
        </se-breadcrumb>;
    }
}
